<script lang="ts">
    import circle from 'src/components/main/marketplace/components/marketplace-intro/circle.svg'
</script>

<section class="main-intro">
    <!--
    <div class="main-intro-content">
        <div class="container">
            <div class="row">
                <div class="col-md-7">
                    <h1 class="intro-title">Welcome to the NFT shop <br><span>Realis Network</span></h1>
                    <div class="description">Here you can search and buy ASSETS</div>
                </div>
                <div class="col-md-5 text-right">
                    <img src="{circle}" class="circle" alt="">
                </div>
            </div>
        </div>
    </div>
    -->
</section>

<style>
    .main-intro {
        position: relative;
        margin-top: 110px;
    }

    .main-intro:before {
        content: "";
        background: linear-gradient(219.76deg, rgba(87, 97, 215, 0.2) 22.71%, rgba(87, 97, 215, 0.14) 49.17%, rgba(87, 97, 215, 0) 77.29%);
        filter: blur(200px);
        width: 1050px;
        height: 437px;
        position: absolute;
        right: 120px;
        top: 20px;
    }

    .text-right {
        text-align: right;
    }

    .circle {
        margin-top: -130px;
    }

    .main-intro-content {
        position: relative;
        padding: 150px 0 0;
        z-index: 2;
    }

    .main-intro-content .container {
        position: relative;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 0 0 30px;
        line-height: 90px;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    .intro-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .description {
        font-size: 18px;
        color: #FFFFFF;
        line-height: 27px;
        margin: 0 0 100px;
        max-width: 550px;
    }

    @media (max-width: 1400px) {
        .intro-title br {
            display: none;
        }
    }

    @media (max-width: 1199px) {
        .intro-title {
            font-size: 56px;
            line-height: 76px;
        }

        .circle {
            max-width: 380px;
        }
    }

    @media (max-width: 991px) {
        .intro-title {
            font-size: 46px;
            line-height: normal;
        }

        .circle {
            max-width: 100%;
        }

        .main-intro-content {
            padding: 100px 0 0;
        }

        .main-intro:before {
            display: none;
        }
    }

    @media (max-width: 767px) {
        .main-intro {
            margin-top: 62px;
        }

        .intro-title {
            font-size: 36px;
            line-height: 48px;
            margin-bottom: 20px;
        }

        .description {
            font-size: 14px;
            margin: 20px 0 0;
            line-height: 21px;
            max-width: 100%;
        }

        .main-intro-content {
            padding: 30px 0 0;
        }

        .circle {
            max-width: 240px;
            margin-top: -200px;
        }
    }
</style>
